module.exports = __webpack_public_path__ + "static/media/down.5003b10b.svg";